import { DefaultSelection36CorrespondenceResponsePayload } from "@api";
import { NA } from "@shared/staticValue";
import LocalContractUserService from "@services/local-contractUser.service";

export default class ManagerResponseDetailItem {
  public Title: string;

  public Note: string;

  public Collapse: boolean;

  constructor(
    managerId: string,
    item: DefaultSelection36CorrespondenceResponsePayload,
    localContractUserService: LocalContractUserService
  ) {
    const role = localContractUserService.getUserRole(managerId);
    const name = localContractUserService.getUserInfo(managerId)?.displayName;
    this.Title = role && name ? `${name}  |  ${role}` : NA;
    this.Note = item.Note ?? NA;
    this.Collapse = false;
  }
}
